<script lang="ts">
  import Hero from '$src/js/components/organisms/hero/Hero.svelte';
  import Vote from '$src/js/components/organisms/vote/Vote.svelte';
  import Header from '$src/js/components/molecules/header/Header.svelte';
  import IntroScreen from '$src/js/components/organisms/intro-screen/IntroScreen.svelte';
  import Footer from '$src/js/components/molecules/footer/Footer.svelte';
  import Story from '$src/js/components/organisms/story/Story.svelte';
  // import Customize from '$src/js/components/organisms/customize/Customize.svelte';
  // import Gallery from '$src/js/components/organisms/gallery/Gallery.svelte';
  // import TrainingKit from '$src/js/components/organisms/training-kit/TrainingKit.svelte';
</script>

<Header />

<Hero />

<Vote />

<Story />

<!-- <Gallery /> -->

<!-- <Customize /> -->

<!-- <TrainingKit /> -->

<Footer />

<IntroScreen />
